import { Injectable } from '@angular/core';
import { AnalyticsTrackingService } from './analytics-tracking-service';
import { CookieConsentService } from './cookie-consent-service';

@Injectable({ providedIn: 'root' })
export class AnalyticsLoaderService {
  private loadPromise: Promise<void> | undefined;

  constructor(
    private cookieConsentService: CookieConsentService,
    private analyticsTrackingService: AnalyticsTrackingService,
  ) {}

  load(ga4MeasurementId: string): Promise<void> {
    if (globalThis.window === undefined) {
      return Promise.resolve();
    }
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      globalThis.dataLayer ??= [];
      globalThis.gtag ??= function () {
        globalThis.dataLayer ??= [];
        // eslint-disable-next-line prefer-rest-params
        globalThis.dataLayer.push(arguments);
      };
      const gtag = globalThis.gtag;

      // Queue consent and configuration before any authentication event.
      gtag('consent', 'default', {
        analytics_storage: this.cookieConsentService.hasAnalyticsConsent()
          ? 'granted'
          : 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });
      gtag('js', new Date());
      gtag('config', ga4MeasurementId, {
        send_page_view: false,
      });

      const script = document.createElement('script');
      script.async = true;
      script.src =
        'https://www.googletagmanager.com/gtag/js?id=' + ga4MeasurementId;

      script.addEventListener('load', () => {
        resolve();
      });
      script.addEventListener('error', () => {
        reject(new Error('Google Analytics script could not be loaded.'));
      });

      document.head.append(script);
    });
    return this.loadPromise;
  }
  setAnalyticsConsent(consent: boolean) {
    if (!globalThis.gtag) return;

    globalThis.gtag('consent', 'update', {
      analytics_storage: consent ? 'granted' : 'denied',
    });
    if (consent) {
      this.analyticsTrackingService.pageView(globalThis.location.pathname);
    }
  }
}
